import script from "./FixedNavbarLink.vue?vue&type=script&setup=true&lang=js"
export * from "./FixedNavbarLink.vue?vue&type=script&setup=true&lang=js"

import "./FixedNavbarLink.vue?vue&type=style&index=0&id=4bdb189d&lang=css"

const __exports__ = script;

export default __exports__